import { render } from "preact";
import { App } from "./App";
import "./design/index.css";

const root = document.getElementById("app");
if (!root) throw new Error("Mount node #app não encontrado");
render(<App />, root);
